import React, { useState } from 'react';
import { getAuthPhotoUrl } from './AuthImage';

/**
 * UserAvatar - Displays a user's photo or initials as fallback
 * Works with all role data shapes (user_info, profile, direct fields)
 */
const UserAvatar = ({ user, size = 'md', className = '', fallbackColor = 'bg-gradient-to-br from-slate-400 to-slate-600' }) => {
  const [imgError, setImgError] = useState(false);

  // Try multiple photo sources
  const rawPhoto = user?.photo_identite || user?.photo_url || user?.photo
    || user?.user_info?.photo_identite || user?.user_info?.photo_url || user?.user_info?.photo
    || user?.profile?.photo || user?.rp_profile?.photo || null;

  // Build authenticated URL if needed
  const photo = rawPhoto ? getAuthPhotoUrl(rawPhoto) : null;

  const prenom = user?.prenom || user?.user_info?.prenom || '';
  const nom = user?.nom || user?.user_info?.nom || '';
  const initials = `${prenom[0] || ''}${nom[0] || ''}`.toUpperCase();
  const alt = `${prenom} ${nom}`.trim() || 'User';

  const sizeClasses = {
    xs: 'w-8 h-8 text-xs',
    sm: 'w-10 h-10 text-sm',
    md: 'w-11 h-11 text-sm',
    lg: 'w-14 h-14 text-lg',
    xl: 'w-24 h-32 text-2xl',
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  if (photo && !imgError) {
    return (
      <img
        src={photo}
        alt={alt}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0 ${className}`}
        data-testid="user-avatar-photo"
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} ${fallbackColor} rounded-full flex items-center justify-center text-white font-bold flex-shrink-0 ${className}`}
      data-testid="user-avatar-initials"
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
